import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderWidth,
  borderStyle,
  borderRadius,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const CardOuter = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing[3]};
  padding-right: ${spacing[6]};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.primary[500]};
  border-radius: ${borderRadius.lg};
  background: ${rawColors.structural[100]};
`;

export const DismissButton = styled.button`
  position: absolute;
  top: ${spacing[2]};
  right: ${spacing[2]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: ${rawColors.text.mediumEmphasis};
  border-radius: ${borderRadius.xs};

  &:hover {
    color: ${rawColors.text.highEmphasis};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
  }
`;

export const Body = styled.p`
  margin: 0;
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.highEmphasis};
`;

export const LinkRow = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const HighlightLink = styled.button`
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  ${typographyMixin("body", 2)}
  color: ${rawColors.primary[500]};

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: ${borderRadius.xs};
  }
`;

export const Separator = styled.span`
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.highEmphasis};
`;

export const ExternalIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${rawColors.primary[500]};
`;
